import { useQuery } from '@tanstack/react-query';

import getEcommerce from 'Api/ecommerce/getEcommerce';

import getEcommerceResponse from './model/response/getEcommerceResponse';

const useGetEcommerce = ({ enabled = false }) => {
  return useQuery({
    queryKey: ['all-ecommerce'],
    queryFn: async () => {
      const response = await getEcommerce();

      return getEcommerceResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 15 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled,
  });
};

export default useGetEcommerce;
